import React, { PropsWithChildren, memo } from 'react';
import Div from '../Div';
import classNames from 'classnames';

type ProgressBarProps = {
  className?: string;
  background?: string;
  progressBarBackground?: string;
  progressBarPercentage?: string;
  dataTestId?: string;
};

const ProgressBar = ({
  className,
  background = 'bg-neutral-100',
  progressBarBackground = 'bg-cm-primary',
  progressBarPercentage = '50%',
  dataTestId,
  ...restProps
}: PropsWithChildren<ProgressBarProps>) => {
  return (
    <Div
      className={classNames('h-1 rounded-cxs', background, className)}
      dataTestId={dataTestId}
      {...restProps}
    >
      <Div
        forceRender
        className={classNames('h-1 rounded-cxs', progressBarBackground)}
        style={{ width: progressBarPercentage }}
      ></Div>
    </Div>
  );
};

export default memo(ProgressBar);
